// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"e8fdce51","239":"6fec68b3","453":"019724cb"}[chunkId] + ".chunk.js";
};